// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D25X","index":"styles_index__1ruDS"};